export default {"src":"/_next/static/media/play-circle-fill.d0962840.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};